import React from 'react'

import {
  BroadcastIcon,
  DashboardIcon,
  FlowsIcon,
  NlpIcon,
  SettingsIcon,
  SupportIcon,
  WidgetIcon,
  AnalyticsIcon,
  UsersIcon,
  ServiceUsersIcon
} from '../uiKit/icons/Icons'

import Dashboard from '../tabs/dashboard/Dashboard'
import Builder from '../tabs/flowBuilder/Builder'
import NLP from '../tabs/nlp/NlpContainer'
import Users from '../tabs/professionals/Professionals'
import ServiceUsers from '../tabs/serviceUsers/ServiceUsers'
import ChatContainer from '../tabs/support/SupportContainer'
import Broadcasts from '../tabs/broadcast/Broadcasts'
import Settings from '../tabs/settings/Settings'
import WidgetContainer from '../tabs/widget/WidgetContainer'
import AnalyticsContainer from '../tabs/analytics/AnalyticsContainer'

import { ComponentNames } from '../constants/componentNames'
import {getSidebarIconColorRGB} from '../globalStylesHelper'

const sidebarIconColor = getSidebarIconColorRGB()

export const mainRoutes = [
  {
    path: 'dashboard',
    icon: <DashboardIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.Dashboard,
    component: Dashboard,
  },
  {
    path: 'analytics',
    icon: <AnalyticsIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: 'Analytics',
    component: AnalyticsContainer,
  },
  {
    path: 'flows',
    icon: <FlowsIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.Flows,
    component: Builder,
  },
  {
    path: 'nlp',
    icon: <NlpIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.NLP,
    component: NLP,
  },
  {
    path: 'professionals',
    icon: <UsersIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.Professionals,
    component: Users,
  },
  {
    path: 'serviceUsers',
    icon: <ServiceUsersIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.ServiceUsers,
    component: ServiceUsers,
  },
  {
    path: 'support',
    icon: <SupportIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.Support,
    component: ChatContainer,
  },
  {
    path: 'broadcast',
    icon: <BroadcastIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.Broadcasts,
    component: Broadcasts,
  },
  {
    path: 'widget',
    icon: <WidgetIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.Widget,
    component: WidgetContainer,
  },
  {
    path: 'settings',
    icon: <SettingsIcon width={40} height={20} color={`${sidebarIconColor}`} />,
    name: ComponentNames.BotSettings,
    component: Settings,
  },
]
